module.exports = __webpack_public_path__ + "static/media/ip.599238b8.svg";